<template>
  <div class="credit-cards-wrap">
    <div class="mb-7 mt-5 d-flex flex-wrap">
      <h2 class="headline">Credit Cards</h2>
      <v-spacer></v-spacer>
      <v-btn
          color="success"
          :small="$vuetify.breakpoint.xs"
          @click="$root.$emit('AddCreditCard')"
      >
        <v-icon v-if="!$vuetify.breakpoint.xs" left>mdi-credit-card-plus-outline</v-icon >
        Add Credit Card
      </v-btn>
    </div>
    <div>
      <v-card v-if="!$vuetify.breakpoint.smAndDown" class="elevation-3 mt-4">
        <v-data-table
          :headers="creditCardHeaders"
          :items="cardsItems"
          :loading="cardsLoading"
          hide-default-footer
          mobile-breakpoint="100"
          class="client-credit-cards"
        >
          <template v-slot:item="{item}">
            <tr>
              <td>
                <img :src="cards[item.brand]" class="card-images mr-2"/> <strong>xxxx {{ item.last4 }} <span v-if="Number(item.default_source === 1)" class="caption info--text">(Default)</span></strong>
              </td>
              <td><strong>{{ item.name }}</strong></td>
              <td><strong>{{ item.exp_month }}/{{ item.exp_year }}</strong></td>
              <td>
                <v-flex style="min-width: 160px;">
                  <v-flex v-if="Number(item.default_source) === 0"
                    class="pr-2 action-link" 
                    @click="$root.$emit('SetDefaultCard', item)"
                  >Set Default <v-icon>mdi-check-circle</v-icon>
                  </v-flex>
                  <template v-else>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-flex
                            v-on="on"
                            class="pr-2 action-link grey--text"
                          >Set Default <v-icon color="grey">mdi-check-circle</v-icon></v-flex>
                        </template>  
                        <span>This Card is Default</span>
                      </v-tooltip>
                  </template>
                </v-flex>
              </td>
            </tr>
          </template>
          <template slot="no-data" v-if="error_code == 404 || error_code == 500">
              <v-btn color="primary" @click="getSubscriptions()">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>

      <template v-else>
        <div v-if="cardsLoading" class="pb-4">
          <v-progress-linear :indeterminate="cardsLoading" class="mb-0 mt-2" :class="{ 'no-opacity': !cardsLoading }" style="height: 2px;"></v-progress-linear>
        </div>
        <template v-if="!cardsLoading">
          <template v-if="cardsItems.length > 0">
            <v-card v-for="(card, index) in cardsItems" :key="`card-${card.id}-${index}`" class="pa-3 mb-3 elevation-3 payment-method-card">
              <v-layout class="mb-2">
                <h3>{{ `Card #${ index + 1}` }}</h3>
              </v-layout>
              <v-layout class="xs12 py-2">
                <v-flex class="xs6">Credit Card Number</v-flex>
                <v-flex class="xs6"><img :src="cards[card.brand]" class="card-images mr-2"/> <strong>xxxx {{ card.last4 }} <span v-if="Number(card.default_source === 1)" class="caption info--text">(Default)</span></strong></v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout class="xs12 py-2">
                <v-flex class="xs6">Name on Card</v-flex>
                <v-flex class="xs6"><strong>{{ card.name }}</strong></v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout class="xs12 py-2">
                <v-flex class="xs6">Expiration Date</v-flex>
                <v-flex class="xs6"><strong>{{ card.exp_month }}/{{ card.exp_year }}</strong></v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-container class="grid-list-lg pa-0">
                <v-layout class="row wrap justify-end xs12 pt-2 mt-1">
                  <v-flex class="sm6 xs12">
                    <v-btn
                      color="primary"
                      class="ma-0"
                      block
                      :disabled="Number(card.default_source) !== 0"
                      @click="$root.$emit('SetDefaultCard', card)"
                    >
                      <v-icon small left>mdi-check-circle</v-icon >
                      Set Default
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </template>
          <template v-else>
            <div>There are no credit cards</div>
          </template>
        </template>
      </template>
    </div>
    <add-credit-card @done="getCreditCards"></add-credit-card>
    <set-default-card @done="getCreditCards"></set-default-card>
  </div>
</template>

<script>
import ApiService from "@/common/api.service"
import AddCreditCard from './AddCreditCard'
import SetDefaultCard from './SetDefaultCard'

export default {
  name: 'AdminCreditCards',
  components: {
    AddCreditCard,
    SetDefaultCard
  },
  data() {
    return {
      accountItems: [],
      cardsItems: [],
      cardsLoading: false,
      defaultSourceLoading: false,
      accountsLoading: false,
      error_code: '',
      creditCardHeaders: [
          {
              text: 'Credit Card Number',
              value: 'last4',
              sortable: false
          },
          {
              text: 'Name on Card',
              value: 'name',
              sortable: false
          },
          {
              text: 'Expiration Date',
              value: 'exp_year',
              sortable: false
          },
          {
              text: 'Actions', 
              sortable: false, 
              width: '170px',
              align: 'left'
          }
      ],
      cards: {
        'Visa': require('@/assets/img/visa.png'),
        'Mastercard': require('@/assets/img/mcard.png'),
        'Discover': require('@/assets/img/dcard.png'),
        'American Express': require('@/assets/img/aexcard.png')
      },

      serverValidation: true,
      serverValidationMessage: 'Oops something went wrong...',
      server_errors: {}
    }
  },
  mounted () {
    this.addCardDialog = Boolean(this.$route.query.add)
    this.getCreditCards()
  },
  methods: {
    getCreditCards () {
      this.cardsLoading = true
      ApiService.get('/admin/credit_cards', { organization_id: this.$route.params.organization_id })
        .then(response => {
          this.cardsItems = response.data.credit_cards
          this.cardsLoading = false
        })
        .catch(error => {
          console.log(error)
          this.cardsLoading = false
        })
    },
    titleCase(str = ''){
      return _.startCase(str.replace(/_/g, ' '));
    },
    resetServerValidation() {
      this.serverValidation = true
      this.serverValidationMessage = 'Oops something went wrong...'
    }
  }
}
</script>

<style scoped>
  .client-credit-cards .card-images {
    height: 12px;
  }

  @media screen and (max-width: 400px) {
    .payment-method-card {
      padding: 16px 10px!important;
    }
  }
</style>
